import { ApiEndpoints, Plantilla } from 'models'
import { apiGet } from 'services/api'

export async function getAllPlantilles(): Promise<{
  status: number
  body?: Plantilla[]
}> {
  return apiGet(ApiEndpoints.getAllTemplates).catch((err) => {
    throw err
  })
}

export async function getPlantillaById(variables: {
  id: string
}): Promise<{ body: Plantilla; status: number }> {
  const path = `${ApiEndpoints.getAllTemplates}/${variables.id}`

  return apiGet(path).catch((err) => {
    throw err
  })
}

export async function getLlistatPlantilles(variables: {
  filtre: object
  pagination: object
}): Promise<{ plantilles: Plantilla[]; totalPlantilles: number; totalPages: number }> {
  const params = Object.values(variables.filtre).every((value) => value === '')
    ? { pagination: variables.pagination }
    : variables

  return apiGet(ApiEndpoints.getTemplatesList, params)
    .then((response) => {
      return { status: response.status, ...response.body }
    })
    .catch((err) => {
      throw err
    })
}
